/* eslint-disable no-console */
'use client'

import { useEffect } from 'react'

import { Button } from '@/components'

export default function Error({
  error,
  reset,
}: {
  error?: Error & { digest?: string }
  reset?: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <div className='flex flex-1 flex-col items-center justify-center'>
      <div className='flex max-w-xs flex-col gap-5'>
        <h2 className='text-slate-900'>Something went wrong!</h2>
        <Button variant='contained' onClick={() => reset && reset()} color='primary'>
          Try again
        </Button>
      </div>
    </div>
  )
}
